import * as Yup from "yup";

export const initialValues = {mobile: "", password: ""};

export const validationSchema = Yup.object({
    mobile: Yup.string()
        .matches(/^09\d{9}$/, "شماره موبایل باید 11 رقم و با 09 شروع شود")
        .required("شماره موبایل را وارد کنید"),
    password: Yup.string()
        .min(5, "رمز عبور باید حداقل 5 کاراکتر باشد")
        .required("رمز عبور را وارد کنید")
});
